import { SelectProps } from 'antd';
import { VFC } from 'react';
import { useMeterModels } from 'hooks/meter_models/useMeterModels';
import { Manufacturer, MeterModel } from '@enmon/commons/lib/tools';
import { FormattedMessage } from 'react-intl';
import { Commodity } from '@enmon/commons/lib/shared';
import { Nullable } from '@enmon/commons';
import { Select } from './Select';
import { SelectMessages as messages } from './messages';

interface MeterModelSelectProps extends SelectProps {
  commodity: Nullable<Commodity>;
  manufacturer: Manufacturer['id'] | undefined;
  value?: MeterModel['id'];
  onChange?: (value: MeterModel['id'] | null) => void;
}

export const MeterModelSelect: VFC<MeterModelSelectProps> = ({ commodity, manufacturer, ...restProps }) => {
  const { isLoading: isMeterModelsLoading, meterModels } = useMeterModels(commodity);

  return (
    <Select
      allowClear
      showSearch
      className="w-100"
      disabled={!manufacturer}
      filterOption={(input, option) =>
        (option?.label?.toString() ?? '').toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      loading={isMeterModelsLoading}
      options={
        manufacturer
          ? meterModels
              .filter(model => model.manufacturer?.id === manufacturer)
              .map(model => ({
                label: model.name,
                value: model.id,
              }))
          : []
      }
      placeholder={<FormattedMessage {...messages.meterModelPlaceholder} />}
      {...restProps}
    />
  );
};
